import { render, staticRenderFns } from "./ClientDocumentsTableModal.vue?vue&type=template&id=847e8f8e&scoped=true&"
import script from "./ClientDocumentsTableModal.vue?vue&type=script&lang=js&"
export * from "./ClientDocumentsTableModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientDocumentsTableModal.vue?vue&type=style&index=0&id=847e8f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847e8f8e",
  null
  
)

export default component.exports